export default __webpack_public_path__ + "static/media/google.1311f1bd.svg";